<template>
</template>
 <script>
 import LoginValidation from '@/components/mixins/Login';
 export default {
  mixins: [LoginValidation],
  async created() {
    try {
      const result = await this.$store.dispatch('app/bootstrap');
      if (result.status === 401) {
        this.$router.push({ name: 'Login' });
      } else {
        this.validateRedirect(result);
      }
      return result;
    } catch (err) {
      return err;
    }
  },
}
</script>
